"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const registries_1 = require("../registries");
registries_1.functionRegistry.set('d', (context) => {
    if (!context.date)
        context.date = new Date('2021/04/28');
    return Math.floor((Date.now() - Number(context.date)) / (1000 * 86400));
});
